export default __webpack_public_path__ + "static/fehrnstrom_ark_logo-cc1c629366cdbcce4f1d43ed38a24972.svg";